import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BiSolidPhoneCall } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import { IoLocationSharp } from "react-icons/io5";
import { FaFacebook, FaTiktok, FaYoutube } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import Planning from "../assets/images/contact-bottom.png";
import axios from "axios";
import { message } from "antd";
import Loader from "./Loader";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/auth/send-email`,
        formData
      );
      if (res.data.success) {
        message.success("Meddelandet skickades!");
        setFormData({ name: "", phone: "", email: "", message: "" });
      } else {
        message.error("Fel vid skickande.");
      }
    } catch (err) {
      console.error(err);
      message.error("Något gick fel. Försök igen senare.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="invest-space">
        {loading && <Loader />}
        <div className="invest-card-sub">
          <div className="contact-card-left-main">
            <div className="contact-card-left">
              <h1 className="contact-left-title">Kontaktinformation</h1>
              <div className="contact-sub-d">
                <div className="contact-detail">
                  <div className="contact-circle">
                    <BiSolidPhoneCall className="contact-circle-icon" />
                  </div>
                  <div className="contact-circle-right">
                    <h3 className="contact-circle-sm-title">ring oss</h3>
                    <Link className="contact-right-link" to="tel:0704872068">
                      0704872068
                    </Link>
                  </div>
                </div>
                <div className="contact-detail">
                  <div className="contact-circle">
                    <FiMail className="contact-circle-icon" />
                  </div>
                  <div className="contact-circle-right">
                    <h3 className="contact-circle-sm-title">E-post</h3>
                    <Link
                      className="contact-right-link"
                      to="mailto:services@soderrenovering.se"
                    >
                      services@soderrenovering.se
                    </Link>
                  </div>
                </div>

                <div className="contact-detail">
                  <div className="contact-circle">
                    <IoLocationSharp className="contact-circle-icon" />
                  </div>
                  <div className="contact-circle-right">
                    <h3 className="contact-circle-sm-title">hitta oss</h3>
                    <Link className="contact-right-link">
                      Medborgarplatsen 11 <br />
                      118 26 Stockholm
                    </Link>
                  </div>
                </div>
              </div>
              <h1 className="contact-left-title">Folja oss</h1>
              <div className="d-flex">
                <div className="me-0">
                  <Link
                    className="contact-circle"
                    target="_blank"
                    to="https://www.facebook.com/profile.php?id=100095169007059"
                  >
                    <FaFacebook className="contact-circle-icon" />
                  </Link>
                </div>
                <div className="me-0">
                  <Link
                    target="_blank"
                    to={"https://www.instagram.com/soderrenovering/"}
                    className="contact-circle"
                  >
                    <FaInstagram className="contact-circle-icon" />
                  </Link>
                </div>

                <div className="me-0">
                  <Link
                    target="_blank"
                    to={
                      "https://www.tiktok.com/@soderrenovering?is_from_webapp=1&sender_device=pc"
                    }
                    className="contact-circle"
                  >
                    <FaTiktok className="contact-circle-icon" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="">
              <img className="w-100" src={Planning} alt="" />
            </div>
          </div>
          <div
            style={{
              borderRadius: "0px",
              background: " #FFFFFF",
              height: "100%",
            }}
            className="invest-card-sub-right shadow"
          >
            <div className="invest-inp-main">
              <div className="invest-inp-main-sub">
                <label className="invest-label">Namn</label>
                <input
                  type="text"
                  className="invest-inp"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John"
                />
              </div>
              <div className="invest-inp-main-sub">
                <label className="invest-label">Kontakta</label>
                <input
                  type="text"
                  className="invest-inp"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="9876"
                />
              </div>
            </div>
            <div className="invest-inp-main-sub-post">
              <label className="invest-label">E-post</label>
              <input
                type="text"
                className="invest-inp"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="E-post"
              />
            </div>
            <div className="invest-inp-main-sub-post">
              <label className="invest-label">Beskrivning</label>
              <textarea
                name="message"
                className="invest-inp"
                rows="6"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="my-5">
              <button
                className="reg-btn border-0"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Skickar..." : "Gratis offert"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
